import getParsedPriceFromFood from '@/utils/getParsedPrice';
import { AppModal, Flex } from '@/components';
import { ConfigProvider, Image, Rate, Tooltip } from 'antd';
import { useSelfContext } from '@/context/SelfContext';
import { useAppContext } from '@/context';
import { envConfig } from '@/configs';
import { round } from '@/utils';
import { useTranslation } from 'react-i18next';

type data = { reserve: UserWeekReserveEntity, meal: SelfMealEntity };

export interface ReserveDetailModalProps {
  variant: ComponentVariant;
  open: boolean;
  hide: () => void;
  data: data;
}

const ReserveDetailModal: React.FC<ReserveDetailModalProps> = ({
  open,
  hide,
  data = { reserve: null, meal: null } as data
}) => {

  const { mode } = useAppContext();
  const { currentSelf, selfText } = useSelfContext();
  const [t] = useTranslation(['common', 'reserve']);

  const score = round(Number((data?.reserve?.foodList?.[0]?.averageScore ?? 0).toFixed(2)), 0.5);
  const voteCount = Number((data?.reserve?.foodList?.[0]?.voteCount ?? 0).toFixed(2));
  const image = (data?.reserve?.foodList?.[0]?.foodImageSrc);

  return (
    <AppModal
      centered
      destroyOnHidden
      footer={null}
      open={open}
      onCancel={hide}
      style={{ maxWidth: '90%' }}
      title={t('reserve:labels.order-details')}
    >
      <Flex direction="column" className="reserve-detail-modal">
        <Flex className="mb-2" direction="row" align="center">
          <div className={`text-base font-bold text-theme-${mode}`}>{data?.meal?.mealTypeName}</div>
          {!envConfig.ui.removePrices && (
            <div className="text-base font-bold !ms-auto !text-app-gray-darker">{getParsedPriceFromFood(data?.reserve, t)}</div>
          )}
        </Flex>
        <Flex className="flex-col lg:flex-row justify-center">
          <Flex direction="column">
            <Flex align="center">
              <div className="text-base">{selfText('choose-self-prefix')}: {currentSelf?.name}</div>
            </Flex>
            <div className="font-bold text-base text-start !text-black">
              {selfText('item-name-prefix')}
              {data?.reserve?.foodNames}
            </div>
            {!data?.reserve?.hideBesideFoodInPanel && ({
              'nurture': data?.reserve?.besideFoodNames &&
                <div className="font-bold text-start !text-black">
                  {t('reserve:labels.beside-food')}: {data?.reserve?.besideFoodNames}
                </div>,
              'health': data?.reserve?.foodTypeTitle &&
                <div className="font-bold text-start !text-black">
                  {t('reserve:labels.doctor-name')}: {data?.reserve?.foodTypeTitle}
                </div>,
              undefined: ''
            }[mode])}
          </Flex>
          <Flex align="center" direction="column" className="mx-auto lg:ms-auto lg:me-0">
            {image &&
              <Image
                width={220}
                src={image}
                preview={false}
                className="aspect-video object-contain object-center rounded-lg shadow-sm"
              />
            }
            <ConfigProvider direction="ltr">
              <Tooltip
                placement="bottom"
                title={`${score} امتیاز از ${voteCount} رای`}>
                <Flex direction="column" className="ltr">
                  <Rate
                    disabled
                    allowHalf
                    className="text-base"
                    value={score} />
                </Flex>
              </Tooltip>
            </ConfigProvider>
          </Flex>
        </Flex>
      </Flex>
    </AppModal>
  );
};

export default ReserveDetailModal;
